import { apiInstance } from "../api";

const endpoint = "/countries";

export function fetchCountries() {
  return apiInstance
    .get(`${endpoint}/?pageSize=0`)
    .then((resp: any) => resp.data.rows);
}
